import { InjectionToken } from "@angular/core";

export const SS_VERSION = new InjectionToken<string>('SS_VERSION', {
    providedIn: 'root',
    factory: () => '3.2.5'
})